module.exports = __webpack_public_path__ + "img/to-do-list.3d3eae0f.png";